import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
 
import { ContactComponent } from './contact/contact.component';
import { OutlineComponent } from './outline/outline.component';
import { QuestionComponent } from './question/question.component';
import { AboutComponent } from './about/about.component';
import { GradeComponent } from './grade/grade.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { ResComponent } from './res/res.component';
import { SplashComponent } from './splash/splash.component';
import { AppComponent } from './app.component';
 
const routes: Routes = 
[
  { path: 'about', component: AboutComponent },
  { path: 'schedule', component: ScheduleComponent },
  { path: 'grade', component: GradeComponent },
  { path: 'res', component: ResComponent },
  { path: 'splash', component: SplashComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'outline', component: OutlineComponent },
  { path: 'question', component: QuestionComponent },
  { path: '', redirectTo: '/splash', pathMatch: 'full' },
  { path: '**', redirectTo: 'splash' }
];
 
@NgModule
({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}

